export default Object.freeze({
    accountOwner: window.i18n.__('SAS SELLSY - AVENUE DU LAZARET 17000 LA ROCHELLE'),
    iban: window.i18n.__('FR76 1090 7008 6103 0211 3904 631'),
    bic: window.i18n.__('CCBPFRPPBDX'),
});